export default __webpack_public_path__ + "static/media/bttb.theme.c69ed80a.less";